import { Component, Input } from '@angular/core';
import type { FeeTableStructure } from 'src/app/models/exchange-fees';

@Component({
    selector: 'fees-table',
    templateUrl: './fees-table.component.html',
    styleUrls: ['./fees-table.component.scss'],
    standalone: false
})
export class FeesTableComponent {
  @Input() title: string;
  @Input() info: string;
  @Input() data: FeeTableStructure;

  discountedView = true;

  constructor() { }

  changeTableView(isDiscounted: boolean) {
    this.discountedView = isDiscounted;
  }
}
